import React, { useState } from "react";
import { useSelector } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import useRDService from "../../../CustomHooks/useRDService";
import { Fingerprint, ArrowLeft, Loader2 } from "lucide-react";

export default function VimoEkycComponent({ onBack, onSuccess }) {
  const username = useSelector((s) => s.auth?.employeeDetails?.username);
  const { lat, lng } = useSelector((s) => s.location);

  const { captureFingerprint, loading: rdLoading, device } = useRDService();
  const { callApi: ekycApi } = useApi("/aeps/vimopay/ekyc-from-user", "POST");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const handleCapture = async () => {
    try {
      setLoading(true);
      setMessage("Place your finger on the scanner...");
      setIsError(false);

      // const wadhValue = "E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=";
      const wadhValue = "18f4CEiXeXcfGXvgWA/blxD+w2pw7hfQPY45JMytkPw=";

      const pidXml = await captureFingerprint(wadhValue);

      if (!pidXml || !pidXml.includes('errCode="0"')) {
        setIsError(true);
        setMessage("Fingerprint capture failed. Please try again.");
        return;
      }

      setMessage("Submitting e-KYC...");

      const res = await ekycApi({
        mid: username,
        pidData: pidXml,
      });

      if (res?.status === "000") {
        setMessage("✅ e-KYC completed successfully!");
        setIsError(false);
        setTimeout(() => {
          if (onSuccess) onSuccess();
        }, 1200);
      } else {
        setIsError(true);
        setMessage(res?.statusDescription || "e-KYC failed. Please try again.");
      }
    } catch (err) {
      setIsError(true);
      setMessage(err?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#F5F7FB] p-6">
      <div className="max-w-lg mx-auto">
        <div className="bg-white rounded-3xl shadow-xl p-8">

          {onBack && (
            <button
              onClick={onBack}
              className="flex items-center gap-2 mb-8 text-slate-600 hover:text-[#12345A] transition"
            >
              <ArrowLeft size={18} />
              Back
            </button>
          )}

          <div className="w-24 h-24 rounded-full bg-indigo-100 flex items-center justify-center mx-auto mb-6">
            <Fingerprint size={50} className="text-indigo-600" />
          </div>

          <h2 className="text-2xl font-semibold text-center text-slate-800 mb-2">
            e-KYC Verification
          </h2>
          <p className="text-slate-500 text-center text-sm mb-8">
            Biometric authentication required for AEPS
          </p>

          <div className="bg-slate-50 rounded-xl p-4 mb-6 text-sm text-slate-600 text-center">
            <p>Device: <strong className={device ? "text-green-600" : "text-red-500"}>{device || "Detecting..."}</strong></p>
            <p className="mt-1">Merchant: <strong>{username}</strong></p>
          </div>

          <button
            onClick={handleCapture}
            disabled={loading || rdLoading}
            className="w-full bg-[#12345A] hover:bg-[#0F2E47] text-white py-4 rounded-xl font-semibold disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {(loading || rdLoading) && <Loader2 className="w-5 h-5 animate-spin" />}
            {loading || rdLoading ? "Capturing..." : "Capture Fingerprint for e-KYC"}
          </button>

          {message && (
            <div className={`mt-5 p-4 rounded-xl text-sm text-center font-medium ${isError ? "bg-red-50 text-red-700 border border-red-200" : "bg-blue-50 text-blue-700 border border-blue-200"}`}>
              {message}
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
